import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { toast } from 'react-toastify'
import { Button, Loading } from 'src/components'
import ROUTES from 'src/constants/routes'
import { VALIDATIONS } from 'src/@types/validations'
import { useResetPassword } from 'src/hooks/api/user'
import { useStyles } from './styles'

type ResetPasswordFormData = {
  email: string
}

export const ResetPassword: React.FC = () => {
  const [isSuccess, setIsSuccess] = useState(false)

  const style = useStyles()
  const navigate = useNavigate()

  const { mutateAsync: resetPassword, isPending } = useResetPassword()

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors }
  } = useForm<ResetPasswordFormData>({
    resolver: yupResolver(VALIDATIONS.User.resetPasswordSchema),
    defaultValues: {
      email: ''
    }
  })

  const email = watch('email')

  const onSubmit = async (data: ResetPasswordFormData) => {
    try {
      await resetPassword(data.email)
      setIsSuccess(true)
      toast.success('Senha temporária enviada com sucesso!')
    } catch (error: any) {
      if (error?.response?.status === 404) {
        toast.error('E-mail não cadastrado no sistema')
      } else {
        toast.error('Erro ao enviar e-mail de recuperação. Tente novamente.')
      }
    }
  }

  const handleBackToLogin = () => {
    navigate(ROUTES.AUTH.LOGIN)
  }

  return (
    <>
      {isPending && <Loading className={style.resetPasswordLoading} />}
      <div className={style.resetPasswordContainer}>
        <div className={style.resetPasswordForm}>
          <div className={style.resetPasswordTitleWrapper}>
            <h1>CONGADO</h1>
          </div>

          {!isSuccess ? (
            <>
              <div className={style.resetPasswordInfoWrapper}>
                <h2>Recuperar Senha</h2>
                <p className={style.resetPasswordDescription}>
                  Digite seu e-mail cadastrado e enviaremos uma senha temporária para você
                </p>
              </div>

              <form onSubmit={handleSubmit(onSubmit)}>
                <div className={style.resetPasswordInput}>
                  <label>E-mail</label>
                  <input
                    id='reset-password__email'
                    type='email'
                    placeholder='Digite seu e-mail'
                    disabled={isPending}
                    {...register('email')}
                  />
                  {errors.email && <span className={style.resetPasswordError}>{errors.email.message}</span>}
                </div>

                <Button type='submit' className='reset-password__button' disabled={isPending}>
                  Enviar
                </Button>

                <Button
                  type='button'
                  className='reset-password__button-secondary'
                  onClick={handleBackToLogin}
                  disabled={isPending}
                >
                  Voltar ao Login
                </Button>
              </form>
            </>
          ) : (
            <>
              <div className={style.resetPasswordSuccessWrapper}>
                <div className={style.resetPasswordSuccessIcon}>✓</div>
                <h2>Senha Enviada!</h2>
                <p className={style.resetPasswordSuccessMessage}>
                  Uma nova senha temporária foi enviada para o e-mail <strong>{email}</strong> e para o WhatsApp do
                  telefone cadastrado.
                </p>
                <p className={style.resetPasswordSuccessInfo}>
                  Por favor, verifique sua caixa de entrada e utilize a senha temporária para fazer login. Recomendamos
                  que você altere sua senha após o primeiro acesso.
                </p>
              </div>

              <Button type='button' className='reset-password__button' onClick={handleBackToLogin}>
                Ir para o Login
              </Button>
            </>
          )}
        </div>
        <div className={style.resetPasswordImageSide}></div>
      </div>
    </>
  )
}
